import React, { Component } from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import axios from 'axios';
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone
} from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search, CSVExport  } from 'react-bootstrap-table2-toolkit';
import '../../Asset/Css/util.css';
import '../../Asset/Css/main.css';
import { Link } from 'react-router-dom';
import global from '../global';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { config } from '../../Constants';
import download from 'downloadjs';
import { Layout } from '../Layout';
import Spinner from '../Spinner';
import ReactNotification from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'
import { store } from 'react-notifications-component';
const { SearchBar } = Search;
const expandRow = {
    renderer: row => (
        <div>
            <a href={row.RemitterCode} target="_blank"> {`Assignment URL: ${row.RemitterCode}`}</a>

            <p className="m-t-10">{`Assignment Updated By: ${row.CreatedBy}`}</p>
            <p className="m-t-10">{`Assignment Updated On: ${row.CreatedOn}`}</p>
        </div>
    ),
    showExpandColumn: true,
    expandByColumnOnly: true
};

export class FetchAssignment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            assignments: [],
            URL: config.url.API_URL,
            columns: [{
                dataField: 'AssignmentID',
                text: 'Assignment ID',
                hidden: true
            },
                {
                    dataField: 'AssignmentCode',
                    hidden: true
                },
                {
                    dataField: 'RN',
                    text: '#',
                    headerAlign: 'center',
                    align: 'center',
                    headerStyle: (colum, colIndex) => {
                        return { width: '5%', textAlign: 'center' };
                    },
                },
            {
                dataField: 'AssignmentName',
                text: 'Assignment',
                headerAlign: 'center',
                align: 'left',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: '25%', textAlign: 'center' };
                },
            }, 
            {
                dataField: 'RemitterName',
                text: 'Remitter',
                headerAlign: 'center',
                align: 'left',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: '25%', textAlign: 'center' };
                },
                
            },
            
            {
                dataField: 'FinancialYear',
                text: 'Financial Year',
                headerAlign: 'center',
                align: 'center',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: '15%', textAlign: 'center' };
                },
                
                },
                {
                    dataField: 'Count',
                    text: 'Declaration Count',
                    headerAlign: 'center',
                    align: 'center',
                    sort: true,
                    headerStyle: (colum, colIndex) => {
                        return { width: '15%', textAlign: 'center' };
                    },
                }, 
                
            {
                dataField: "Action",
                text: "Action",
                headerAlign: 'center',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { width: '15%', textAlign: 'center' };
                },
                formatter: (rowContent, row) => {
                    return (
                        <div>
                            <button className="btn btn-primary p-10" title="Edit Assignment Details"
                                onClick={e => {
                                    e.persist();
                                    FetchAssignment.handleEdit(row.AssignmentCode, this.state.URL)
                                }}> <FontAwesomeIcon icon="pencil-alt" /> </button>

                            <button className="btn btn-info p-10 m-l-10"
                                title="Download Log File"
                                onClick={e => {
                                    e.persist();
                                    FetchAssignment.handleDownload(row.AssignmentCode, row.RemitterName)
                                }}> <FontAwesomeIcon icon="cloud-download-alt" /> </button>
                        </div>
                    )
                }
            },
            ],
            RemitterCode: '',
            token:'',
            loading: false
        }
    }

    componentDidMount() {

        axios.get(global.Assignment.GetAssignmentAPI,
            { headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` } },
            { responseType: 'json' })
            .then(response => {
                debugger
                if (response.status) {
                    this.setState({
                        assignments: response.data.data
                    });
                }
                else {
                    this.setState({
                        assignments: []
                    });
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    static handleEdit(rowContent, URL) {
        debugger
        window.location.href =  URL + `/Nexdigm/Add-Assignment` + '?ACE=' + window.btoa(rowContent) + '&Type='+ window.btoa('E');
    }

   
    showNoti(title, message, type) {

        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 10000,
                onScreen: true
            }
        });

    };

    handleSampleDownload = (e) => {
        axios.get(global.Assignment.DownloadSampleAPI,
            {
                headers: { "Authorization": `Bearer ${localStorage.getItem('token')}`, 'Accept': 'application/xlsx' },
                responseType: 'blob'
            })
            .then(response => {
                this.setState({ loading: false });
                this.showNoti("Notification", "File Downloaded Successfully", "success");

                const content = response.headers['content-type'];
                const fileName = "Sample Template.xlsx"
                download(response.data, fileName, content)
            })
            .catch(error => {
                this.setState({ loading: false });
                 console.log(error);
                this.showNoti("Notification", "Error Occurred While Downloading Template", "danger");
               
            });
    }

    static handleDownload(rowContent, rowContent1) {
        axios.get(global.Assignment.DownloadAssignmentLogAPI + '?assignmentCode=' + rowContent + '&remitterName=' + rowContent1,
            {
                headers: { "Authorization": `Bearer ${localStorage.getItem('token')}`, 'Accept': 'application/zip' },
                responseType: 'blob'
            })
            .then(response => {
                const content = response.headers['content-type'];
                const fileName = rowContent + "_" + moment().format("DD/MM/YYYY") + ".zip"

                console.log(response);
                download(response.data, fileName, content)
            })
            .catch(error => {
                console.log(error);
            });
    }


    render() {
        if (this.state.loading) return <Spinner />;
        let contentFooter = Layout.RenderFooter();
        const options = {
            custom: true,
            paginationSize: 4,
            pageStartIndex: 1,
            firstPageText: 'First',
            prePageText: 'Back',
            nextPageText: 'Next',
            lastPageText: 'Last',
            nextPageTitle: 'First page',
            prePageTitle: 'Pre page',
            firstPageTitle: 'Next page',
            lastPageTitle: 'Last page',
            showTotal: true,
            totalSize: this.state.assignments.length
        };

        const contentTable = ({ paginationProps, paginationTableProps }) => (
            <div>
                <ToolkitProvider
                    keyField="AssignmentID"
                    columns={this.state.columns}
                    data={this.state.assignments}
                    search
                    
                >
                    {
                        toolkitprops => (
                            <div>
                                <SearchBar {...toolkitprops.searchProps} />
                                <BootstrapTable
                                    hover
                                    {...toolkitprops.baseProps}
                                    {...paginationTableProps}
                                    wrapperClasses="table-responsive"
                                    expandRow={expandRow} />
                            </div>
                        )
                    }
                </ToolkitProvider>
                <PaginationListStandalone {...paginationProps} />
            </div>
        );
        let content = Layout.RenderNavMenu()
        var url = config.url.API_URL;

        return (
            <div>
                <ReactNotification />
                {content}
                <div className="Nexdigm">
                    <ol className="breadcrumb btn-Nexdigm">
                        <li><a href={this.state.URL + "/Nexdigm/Dashboard" } className="text-white"><FontAwesomeIcon icon="home" /> Home</a></li>
                        <li><a className="text-white">Assignments</a></li>
                    </ol>
                </div>
                <div className="content-page">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="header-title m-b-10 ">Assignment Details</h4>

                            <button className="btn btn-primary float-right m-r-10 m-b-10">
                                <a href={this.state.URL + "/Nexdigm/Add-Assignment"} style={{ color: 'white' }}> Add New Assignment</a>
                            </button>
                            <PaginationProvider
                                pagination={
                                    paginationFactory(options)
                                }
                            >
                                {contentTable}
                            </PaginationProvider>

                        </div>
                    </div>
                </div>
                {contentFooter}
            </div>
        );
    }
}
